class EditorManager {
  constructor(editor) {
    this.editor = editor;
  }
  editor;
  disposables = /* @__PURE__ */ new Set();
  /**
   * Register a teardown function to run on `dispose()`. The universal way for a manager to
   * make a resource "see itself out". Returns the same function for convenience.
   */
  register(dispose) {
    this.disposables.add(dispose);
    return dispose;
  }
  /**
   * Subscribe to an editor bus event and register the matching unsubscribe, so the listener
   * is removed automatically on `dispose()`.
   */
  addEditorEvent(event, fn) {
    this.editor.on(event, fn);
    this.register(() => this.editor.off(event, fn));
  }
  /** @internal */
  dispose() {
    this.disposables.forEach((d) => d());
    this.disposables.clear();
  }
}
export {
  EditorManager
};
//# sourceMappingURL=EditorManager.mjs.map
